module.exports = __webpack_public_path__ + "img/fencecrossing.e8b761b9.webp";